'use strict';

export class Accessibility {
	constructor() {
		this.$body = jQuery('.js-mbody');
		this.keyboard_navigation_class = 'keyboard_navigation_detected';
		this.events = ['Tab', 'Enter', 'Space'];
	}
	
	init() {
		this.$body
			.on('keydown', this.keyboard_navigation_detection.bind(this))
			.on('mousedown', this.keyboard_navigation_detection.bind(this));
	}
	keyboard_navigation_detection(event) {
		if (this.events.indexOf(event?.key) !== -1) {
			if (!this.$body.hasClass(this.keyboard_navigation_class)) {
				this.$body.addClass(this.keyboard_navigation_class);
			}
		} else {
			if (this.$body.hasClass(this.keyboard_navigation_class)) {
				this.$body.removeClass(this.keyboard_navigation_class);
			}
		}
	}
}
